import BossModel from "@/models/BossModel";

export default class WidgetTemplate extends BossModel {

    static apiUrl = 'platinum-widget/templates';

    static entity = 'PlatinumWidgetTemplates';

    static primaryKey = 'key';

    static fields() {
        return {
            description: this.attr(null),
            isFillable: this.boolean(null),
            isPlaceable: this.boolean(null),
            key: this.attr(null),
            maxWidthPercentage: this.number(null),
            minWidthPercentage: this.number(null),
            model_name: this.attr(null),
            name: this.attr(null),
        };
    }

    /**
     *
     * @param term
     * @returns {*}
     */
    static getAll(term = '') {
        if (term.length > 0) {
            let match = new RegExp(term, "gi");
            return this.all().filter(item => item.name.match(match) || item.description.match(match));
        }

        return this.all();
    }

    static getPlaceables() {
        return this.query().where('isPlaceable', true).get();
    }

    /**
     *
     * @param modelName
     * @returns {*}
     */
    static byModelName(modelName) {
        return this.all().find(item => item.model_name === modelName);
    }

    /**
     *
     * @param key
     * @returns {*}
     */
    static byKey(key) {
        return this.all().find(item => item.key === key);
    }

    /**
     *
     * @param column
     * @returns {boolean|boolean}
     * @constructor
     */
    FitsInColumn(column) {
        let boxWidth = column.ActualWidthPercentage();

        return this.minWidthPercentage <= boxWidth && this.maxWidthPercentage >= boxWidth;
    }

    icon() {
        switch (this.model_name) {
            case 'Accordion':
                return 'mdi-arrow-collapse-vertical';
            case 'Information':
                return 'mdi-image-text';
            case 'Photo':
                return 'mdi-image';
            case 'Gallery':
                return 'mdi-image-multiple';
            case 'Map':
                return 'mdi-map-marker';
            case 'HotelList':
                return 'mdi-bed';
            case 'Video':
                return 'mdi-video';
            case 'Title':
                return 'mdi-subtitles-outline';
            case 'VisualLink':
                return 'mdi-link';
            default:
                console.warn(this.model_name + ' icon is not defined');
                return 'mdi-skull-crossbones';
        }
    }
}
